export default [
    {
        path: 'registro-vacinacao',
        component: () => import(/* weimunizacaockChunkName: 'imunizacao-registro-vacinacao' */ '@/views/imunizacao/registro-vacinacao/Index'),
        redirect: 'registro-vacinacao/index',
        children: [
            {
                name: 'imunizacao-registro-vacinacao-index',
                path: 'index',
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-registro-vacinacao' */ '@/views/imunizacao/registro-vacinacao/List.vue'),
            },
            {
                name: 'imunizacao-registro-vacinacao-create',
                path: 'create/:id/:filaId?',
                props: route => ({
                    id: parseInt(route.params.id),
                    filaId: route.params.filaId,
                }),
                component: () => import(/* weimunizacaockChunkName: 'imunizacao-registro-vacinacao' */ '@/views/imunizacao/registro-vacinacao/Form.vue'),
            },
        ],
    },
]